import { useEffect, useState } from "react";
import _ from "lodash";
// import 'antd/dist/antd.css';
import { Table } from "antd";
import dataConstant from "../constants/dataConstant";
import { IconButton, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import ReplayIcon from "@mui/icons-material/Replay";
import DataConstant from "../constants/dataConstant";

const GridComponent = ({
  rowKey,
  columns,
  dataSource,
  getGridData,
  totalCount,
  scroll,
  refresh,
  isShowAddButton,
  addCallbackMethod,
  deleteCallbackMethod,
  SearchText,
  pageNumber,
  enableRowSelection,
  onSelectChange,
  loading,
  expandedRowRender,
  tableRequest,
}) => {
  const [request, setRequest] = useState(
    JSON.parse(JSON.stringify(dataConstant.tableRequest))
  );
  const [pagination, setPagination] = useState({
    current: dataConstant.pagination.pageNumber,
    defaultPageSize: dataConstant.pagination.defaultPageSize,
    showSizeChanger: dataConstant.pagination.showSizeChanger,
    pageSizeOptions: dataConstant.pagination.pageSizeOptions,
    total: 0,
    showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
  });

  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [isMultipleDelete, setIsMultipleDelete] = useState(false);
  const [Columns, setColumns] = useState([]);

  useEffect(() => {
    setRequest(tableRequest);
    setPagination({ ...pagination, current: pageNumber, total: totalCount });
    setColumns(columns);
  }, [pageNumber, SearchText, totalCount, tableRequest]);

  const getGridDatas = (resetData = false, pageNumber = 1) => {
    if (resetData) {
      setRequest(JSON.parse(JSON.stringify(dataConstant.tableRequest)));
      setPagination({
        current: dataConstant.pagination.pageNumber,
        defaultPageSize: dataConstant.pagination.defaultPageSize,
        showSizeChanger: dataConstant.pagination.showSizeChanger,
        pageSizeOptions: dataConstant.pagination.pageSizeOptions,
        total: 0,
        showTotal: (total, range) =>
          `${range[0]}-${range[1]} of ${total} items`,
      });
      setSelectedRowKeys([]);
      setIsMultipleDelete(false);
      getGridData(
        JSON.parse(JSON.stringify(dataConstant.tableRequest)),
        pageNumber
      );
    } else {
      getGridData(request, pageNumber);
    }
  };

  const handleTableChange = (pager, filters, sorter) => {
    const { current, pageSize } = pager;

    setPagination({ ...pagination, current: current });
    setSelectedRowKeys([]);
    setIsMultipleDelete(false);

    const requestObject = {
      pageNumber: current,
      rowsPerPage: pageSize,
      SearchText,
      SearchColumns: [],
      sortColumns: {
        sortColumnName:
          sorter.field && sorter.order
            ? sorter.field
            : DataConstant.tableRequest.sortColumns.sortColumnName,
        sortOrder:
          (sorter.order === "descend" ? "desc" : "") ||
          (sorter.order === "ascend" ? "asc" : "") ||
          DataConstant.tableRequest.sortColumns.sortOrder,
      },
    };
    getGridData(requestObject, current);

    if (onSelectChange) {
      onSelectChange([], []);
    }
  };

  const pageRefresh = () => {
    getGridData(JSON.parse(JSON.stringify(dataConstant.tableRequest)));
    setPagination({
      current: dataConstant.pagination.pageNumber,
      defaultPageSize: dataConstant.pagination.defaultPageSize,
      showSizeChanger: dataConstant.pagination.showSizeChanger,
      pageSizeOptions: dataConstant.pagination.pageSizeOptions,
      total: 0,
      showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
    });
    setSelectedRowKeys([]);
    setIsMultipleDelete(false);
  };

  const handleSearch = (selectedKeys, dataIndex, dataType, isQuickSearch) => {
    const searchobject = _.filter(request.SearchColumns, (item) => {
      return item.isQuickSearch !== true;
    });

    const objSearchData = {
      searchedColumn: dataIndex,
      searchText: !isQuickSearch
        ? selectedKeys[0] && selectedKeys[0].trim()
        : selectedKeys,
      ColumnDataType: dataType,
      isQuickSearched: isQuickSearch,
    };

    setRequest({
      ...request,
      PageNumber: dataConstant.pagination.pageNumber,
      SearchColumns: searchobject.push(objSearchData),
    });

    getGridDatas(false, dataConstant.pagination.pageNumber);
  };

  const handleReset = (clearFilters, dataIndex) => {
    clearFilters();
    const searchobject = _.filter(request.SearchColumns, (item) => {
      return item.SearchColumns !== dataIndex;
    });

    setRequest({
      ...request,
      PageNumber: dataConstant.pagination.pageNumber,
      SearchColumns: searchobject,
    });

    setPagination({
      ...pagination,
      current: dataConstant.pagination.pageNumber,
    });

    getGridDatas(false, dataConstant.pagination.pageNumber);
  };

  const searchedColumnIndex = (dataIndex) => {
    return request.SearchColumns.findIndex(
      (item) => item.searchedColumn === dataIndex
    );
  };

  const addCallback = () => {
    addCallbackMethod();
  };

  const deleteCallback = () => {
    deleteCallbackMethod(selectedRowKeys, isMultipleDelete);
  };

  const onSelectChanges = (selectedRowKeys, selectedRows) => {
    if (selectedRowKeys.length > 0) {
      setSelectedRowKeys(selectedRowKeys);
      setIsMultipleDelete(true);
    } else {
      setSelectedRowKeys([]);
      setIsMultipleDelete(false);
    }

    if (onSelectChange) {
      onSelectChange(selectedRowKeys, selectedRows);
    }
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChanges,
  };
  return (
    <>
      <Table
        className="sm:px-12"
        rowKey={(record) => record[rowKey]}
        columns={Columns}
        dataSource={dataSource}
        pagination={pagination}
        loading={loading}
        onChange={handleTableChange}
        rowSelection={enableRowSelection ? rowSelection : null}
        size="middle"
        scroll={scroll}
        bordered
        expandedRowRender={expandedRowRender}
        title={() => (
          <div className="text-right">
            {isMultipleDelete && (
              <Tooltip title={dataConstant.Delete}>
                <IconButton onClick={() => deleteCallback()}>
                  <DeleteIcon />
                </IconButton>
              </Tooltip>

              // <Tooltip placement="bottom" title="Delete">
              //   <Button
              //     icon={<DeleteOutlined />}
              //     className="ant-btn mr-1 ant-btn-sm ant-btn-icon-only"
              //     onClick={() => deleteCallback()}
              //   />
              // </Tooltip>
            )}

            <Tooltip title={dataConstant.Refresh}>
              <IconButton onClick={pageRefresh}>
                <ReplayIcon />
              </IconButton>
            </Tooltip>
            {/* <Tooltip placement="bottom" title="Refresh">
              <Button
                className="ant-btn mr-1 ant-btn-sm ant-btn-icon-only"
                onClick={pageRefresh}
              >
                <ReplayIcon />
                <i className="fa fa-refresh" />
              </Button>
            </Tooltip> */}

            {/* {isShowAddButton && (
              <Tooltip placement="bottom" title="Add">
                <Button
                  icon={<PlusOutlined />}
                  className="ant-btn mr-1 ant-btn-sm ant-btn-icon-only"
                  onClick={() => addCallback()}
                >
                  <i className="fa fa-plus" />
                </Button>
              </Tooltip>
            )} */}
          </div>
        )}
      />
    </>
  );
};

export default GridComponent;
